import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FinanceProductType } from '../api/types';

const useFormatFinanceProductType = () => {
    const { t } = useTranslation(['financeProductDetails']);

    return useCallback(
        (type: FinanceProductType) => {
            switch (type) {
                case FinanceProductType.HirePurchase:
                    return t('financeProductDetails:types.hirePurchase');

                case FinanceProductType.HirePurchaseWithBalloonGfv:
                    return t('financeProductDetails:types.hirePurchaseWithBalloonGFV');

                case FinanceProductType.LeasePurchase:
                    return t('financeProductDetails:types.leasePurchase');

                case FinanceProductType.HirePurchaseWithBalloon:
                    return t('financeProductDetails:types.hirePurchaseWithBalloon');

                case FinanceProductType.Lease:
                    return t('financeProductDetails:types.lease');

                case FinanceProductType.DeferredPrincipal:
                    return t('financeProductDetails:types.deferredPrincipal');

                case FinanceProductType.UcclLeasing:
                    return t('financeProductDetails:types.ucclLeasing');

                default:
                    return '';
            }
        },
        [t]
    );
};

export default useFormatFinanceProductType;
